import { render, staticRenderFns } from "./NuData.vue?vue&type=template&id=af93cbc6&scoped=true"
import script from "./NuData.vue?vue&type=script&lang=js"
export * from "./NuData.vue?vue&type=script&lang=js"
import style0 from "./NuData.vue?vue&type=style&index=0&id=af93cbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af93cbc6",
  null
  
)

export default component.exports